export default function initializeChatChannel(chat) {
  function log(message) {
    console.log("chat:", message);
  }

  return App.cable.subscriptions.create(
    {
      channel: "ChatChannel",
      chat_id: chat.chatId,
    },
    {
      initialized() {},

      // Triggered on connection. Assuming everything is read on page load.
      connected() {
        log(`connected chat=${chat.chatId}`);
        this.markRead();
      },

      disconnected() {
        log(`disconnected chat=${chat.chatId}`);
      },

      rejected() {
        log("connection rejected");
      },

      typing() {
        log("sending typing signal");
        this.perform("typing", { admin: true });
      },

      speak(comment) {
        log(`Sent message to chat ${chat.chatId}: ${comment}.`);
        let container = $("#comments-container");
        container.scrollTop(container.scrollHeight);
        this.perform("speak", { comment: comment });
      },

      deleteComment(commentId) {
        log(`Deleting comment: ${commentId}`);
        this.perform("delete_comment", {
          comment_id: commentId,
        });
      },

      markRead() {
        if (document.visibilityState === "visible") {
          log("marking chat as read");
          this.perform("mark_read");
        }
      },

      received(data) {
        switch (data.message_type) {
          case "chat_message":
            chat.chatRenderer.fetchAndReplaceComment(data.message);
            break;

          case "update_approval":
          case "pin_comment":
          case "save_message":
            chat.chatRenderer.fetchAndReplaceComment(data.message);
            break;

          case "deleted_message":
            chat.chatRenderer.renderSingleDeletedMessage(data.message.data);
            log("refreshed deleted comments.");
            break;

          case "typing":
            chat.typingReceivingManager.pushToStack(data.message);
            break;

          case "full_chat":
            chat.chatRenderer.refreshChat();
            break;

          default:
            log(`unknown message type: ${data.message_type}`);
        }
      },
    }
  );
}
